import React from 'react';

// ═══════════════════════════════════════════════════════════════════════════
//  THE QPS HUB WORDMARK
//
//  QPS in the page's ink, HUB in the brand green. One component, used on the
//  marketing rail, in every portal header, on the sign-in screens and on the
//  printed work order — so there is exactly one place the logo is drawn and it
//  cannot drift into four slightly different versions of itself.
//
//  ── WHY THE GREEN CHANGES ─────────────────────────────────────────────────
//  `--blue` is the brand accent and it is theme-aware for a measured reason:
//  the mint (#52D094) is 1.89:1 on a white page, which is unreadable, and
//  9.3:1 on a dark one. So HUB sets in the deep green (#12503A, 9.4:1) on
//  light and in the mint on dark. The mark keeps its colour relationship in
//  both themes without ever being illegible in either.
//
//  QPS inherits `currentColor`, so the bar it sits on decides its colour — the
//  onyx nav gives it white, a white bar gives it ink — and nothing needs a
//  second variant per background.
// ═══════════════════════════════════════════════════════════════════════════

// `size` is optional on purpose. Passing one writes an inline font-size, and an
// inline style cannot be overridden by a media query — which is exactly how the
// marketing rail ended up rendering a 27px wordmark on a 393px phone and
// pushing its own actions onto a second row. Leave it out wherever a stylesheet
// should own the size.
export default function Wordmark({ size, className = '', style }) {
  return (
    <span
      className={`qps-wordmark ${className}`.trim()}
      style={size ? { fontSize: size, ...style } : style}
      aria-label="QPS Hub"
    >
      QPS<i>HUB</i>
    </span>
  );
}
